const getProviderName = (name) => {
  if (!name) return "CGA App";
  if (name.toLowerCase() === "internal") {
    return "Mithril App";
  }
  return name;
};
export const setOngoingIncidentData = (el = {}) => ({
  CreatedAt: el.CreatedAt || null,
  UpdatedAt: el.UpdatedAt || null,
  DeletedAt: el.DeletedAt || null,
  id: el.ID || null,
  campus_id: el.campus_id || null,
  district_id: el.district_id || null,
  initiated_by_id: el.initiated_by_id || null,
  status: el.status || null,
  provider_name: getProviderName(el.external_source || el.provider_name),
  resolved_at: el.resolved_at || null,
  verified_at: el.verified_at || null,
  notes: el.notes || null,
  responder_id: el.responder_id || null,
  last_modified_by_id: el.last_modified_by_id || null,
  incident_box_folder_id: el.incident_box_folder_id || null,
  campus: el.campus || null,
  district: el.district || null,
  district_name: el.district_name || null,
  campus_name: el.campus_name || null,
});
